import { placeholderScript } from './placeholder-script';
import { uploadFile } from './upload-file';
import { proStudioService, sendProStudioEvent } from '../xstate/app.xstate';
import type { ProStudioContext } from '../xstate/prostudio.xstate.types';

export { placeholderScript };

/**
 * Upload a placeholder for each command, one at a time, to the open draft —
 * the same endpoint and draft update as Actions' own upload
 * (`use-upload-python-files.ts`), without the hook. Resolves with the
 * commands that uploaded.
 */
export const uploadPlaceholderScripts = async (
  commands: { command: string; decisionVariable: string; answer?: string }[]
): Promise<string[]> => {
  const ctx = proStudioService.getSnapshot().context;
  const projectId = ctx.project?.id;
  const versionId =
    ctx.customerId && ctx.botName && ctx.draftVersion
      ? `${ctx.customerId}.${ctx.botName}.${ctx.draftVersion}`
      : undefined;
  if (!projectId || !versionId || !commands.length) return [];

  const uploaded: string[] = [];
  for (const { command, decisionVariable, answer } of commands) {
    const file = new File(
      [placeholderScript(command, decisionVariable, answer)],
      `${command}.py`,
      { type: 'text/x-python' }
    );
    // eslint-disable-next-line no-await-in-loop -- one at a time, like Actions
    await new Promise<void>((resolve) => {
      uploadFile({
        url: `${import.meta.env.FE_ADMIN_URL}/rest/bot-manager/${projectId}/${versionId}/scripts`,
        file: [file],
        type: 'scriptFile',
        onChange: ({ data }) => {
          sendProStudioEvent({
            type: 'updateDraftData',
            draft:
              (data as ProStudioContext['draft']) ||
              proStudioService.getSnapshot().context.draft,
            action: 'upload',
          });
          uploaded.push(command);
          resolve();
        },
        error: (error) => {
          console.error('[placeholder-scripts] upload failed', command, error);
          resolve();
        },
      });
    });
  }
  return uploaded;
};
